

// Loader Action

export const setLoader = (loader, msg) => ({
    type: 'LOADER',
    loader,
    loaderText: msg
});
  
// Snackbar Action
export const openSnackbar = (message, msgType, time) => ({
    type: 'OPEN_SNACKBAR',
    message,
    msgType,
    time
});

export const closeSnackBar = () => ({
    type: 'CLOSE_SNACKBAR',
});

// Common Action

export const mobVerificationGenerateOtp = payload => ({
    type: 'GENERATE_MOBILE_VERIFICATION_OTP',
    payload,
    loader: true
});

export const setMobVerificationGenerateOtpRes = res => ({
    type: 'SET_MOB_VERIFICATION_GENERATE_OTP',
    res,
    loader: false
});

export const setMobVerificationVerifyForceOtpRes = res => ({
    type: 'SET_MOB_VERIFICATION_VERIFY_FORCE_OTP',
    res,
    loader: false
});

export const setEmailVerificationOtpRes = res => ({
    type: 'SET_EMAIL_VERIFICATION_OTP',
    res,
    loader: false
});

export const mobVerificationResendOtp = payload => ({
    type: 'MOBILE_VERIFICATION_RESEND_OTP',
    payload,
    loader: true
});

export const setMobVerificationResendOtpRes = res => ({
    type: 'SET_MOB_VERIFICATION_RESEND_OTP',
    res,
});

export const mobVerificationVerifyOTP = payload => ({
    type: 'MOBILE_VERIFICATION_VERIFY_OTP',
    payload,
    loader: true
});

export const setMobVerificationVerifyOtpRes = res => ({
    type: 'SET_MOB_VERIFICATION_VERIFY_OTP',
    res,
    locader: false
});

export const getCurrentState = payload => ({
    type: 'GET_CURRENT_STATE',
    payload,
    loader: true
});

export const setCurrentState = res => ({
    type: 'SET_CURRENT_STATE',
    res,
});

export const updateKycType = payload => ({
    type: 'UPDATE_KYC_TYPE',
    payload,
    loader: true
});

export const updateKycTypeRes = res => ({
    type: 'UPDATE_KYC_TYPE_RES',
    res,
});

export const getConsentForm = payload => ({
    type: 'GET_CONSENT_FORM',
    payload,
    loader: true
});

export const setConsentData = res => ({
    type: 'SET_CONSENT_FORM',
    res
});

export const checkCompletedSteps = res => ({
    type: 'CHECK_COMPLETED_STEPS',
    res
});

export const submitConsentForm = payload => ({
    type: 'SUBMIT_CONSENT_FORM',
    payload,
    loader: true
});

export const panVerification = (payload, msg) => ({
    type: 'PAN_VERIFICATION',
    payload,
    loader: true,
    loaderText: msg
});

export const panVerificationRes = res => ({
    type: 'PAN_VERIFICATION_RES',
    res
});

export const userPanNameUpdate = (payload, msg) => ({
    type: 'USER_PAN_NAME_UPDATE',
    payload,
    loader: true,
    loaderText: msg
});

export const userPanNameUpdateRes = res => ({
    type: 'USER_PAN_NAME_UPDATE_RES',
    res
});

export const searchCKyc = (payload, msg) => ({
    type: 'SEARCH_CKYC',
    payload,
    loader: true,
    loaderText: msg
});

export const setLimitedKyc = (res) => ({
    type: 'SET_LIMITED_KYC',
    res
});

export const setCkycRes = res => ({
    type: 'CKYC_RES',
    res
})

export const getCaptcha = payload => ({
    type: 'GET_CAPTCHA',
    payload,
    loader: true
});

export const setCaptchaRes = res => ({
    type: 'SET_CAPTCHA_RES',
    res
});

export const getOtp = payload => ({
    type: 'GET_OTP',
    payload,
    loader: true
});

export const setOtpRes = res => ({
    type: 'SET_OTP_RES',
    res
});

export const otpMaxLimitExceededRes = res => ({
    type: 'OTP_MAX_LIMIT_EXCEEDED_RES',
    res
});

export const submitOtp = payload => ({
    type: 'SUBMIT_OTP',
    payload,
    loader: true
});

export const submitOtpRes = res => ({
    type: 'SUBMIT_OTP_RES',
    res,
    loader: false
});

export const submitOtpFailedRes = res => ({
    type: 'SUBMIT_OTP_FAILED_RES',
    res
});

export const getVideoLink = payload => ({
    type: 'GET_VIDEO_LINK',
    payload,
    loader: true
});

export const setVideoLinkRes = res => ({
    type: 'SET_VIDEO_LINK_RES',
    res
});




/////////////// Document KYC

export const submitPoiPhoto = payload => ({
    type: 'POI_PHOTO',
    payload,
    loader: true
});

export const photoRes = res => ({
    type: 'PHOTO_RES',
    res
});

export const poiRes = res => ({
    type: 'POI_RES',
    res
});

export const submitPoa = payload => ({
    type: 'SUBMIT_POA',
    payload,
    loader: true
});

export const poaRes = res => ({
    type: 'POA_RES',
    res,
});

export const getZipCodeData = payload => ({
    type: 'GET_ZIP_CODE_DATA',
    payload,
    loader: true
});

export const zipCodeRes = res => ({
    type: 'ZIP_CODE_DATA_RES',
    res
});


export const setPoaDataLocal = payload => ({
    type: 'SET_POA_LOCAL',
    payload
});

export const getPoaDataLocal = res => ({
    type: 'GET_POA_LOCAL',
    res
});

export const confirmAadhaarXml = payload => ({
    type: 'CONFIRM_AADHAAR_XML',
    payload,
    loader: true
});

export const confirmAadhaarXmlRes = res => ({
    type: 'CONFIRM_AADHAAR_XML_RES',
    res
});

export const saveUserLocation = payload => ({
    type: 'SAVE_USER_LOCATION',
    payload
});

export const saveUserLocationRes = res => ({
    type: 'SAVE_USER_LOCATION_RES',
    res
});

export const checkPhotoLiveness = payload => ({
    type: 'CHECK_PHOTO_LIVENESS',
    payload,
    loader: true
});

export const checkPhotoLivenessFailedRes = res => ({
    type: 'CHECK_PHOTO_LIVENESS_FAILED_RES',
    res
});

export const checkDocumentPhotoLiveness = payload => ({
    type: 'CHECK_DOCUMENT_PHOTO_LIVENESS',
    payload,
    loader: true
});

export const togglePageEditFlag = res => ({
    type: 'TOGGLE_PAGE_EDIT',
    res
});

export const openCancelProcessDialog = res => ({
    type: 'OPEN_CANCEL_PROCESS_DIALOG',
    res
});

export const confirmCkycAddress = payload => ({
    type: 'CONFIRM_CKYC_ADDRESS',
    payload,
    loader: true
});

export const confirmCkycAddressRes = res => ({
    type: 'CONFIRM_CKYC_ADDRESS_RES',
    res
});

export const hideCkycVerification = res => ({
    type: 'HIDE_CKYC_VERIFICATION',
    res
});

export const generateKarzaOtp = payload => ({
    type: 'GENERATE_KARZA_OTP',
    payload,
    loader: true
});

export const generateKarzaOtpRes = res => ({
    type: 'GENERATE_KARZA_OTP_RES',
    res,
    loader: false
});

export const submitKarzaOtp = (payload, msg) => ({
    type: 'SUBMIT_KARZA_OTP',
    payload,
    loader: true,
    loaderText: msg
});

export const kycDeclined = res => ({
    type: 'KYC_DECLINED_KYC0001',
    res,
    loader: false
});

export const quickKycGenerateOtp = (payload, msg) => ({
    type: 'QUICK_KYC_GENERATE_OTP',
    payload,
    loader: true,
    loaderText: msg
});

export const quickKycGenerateOtpRes = res => ({
    type: 'QUICK_KYC_GENERATE_OTP_RES',
    res,
    loader: false
});
export const setOldCKycMsg = res => ({
    type: 'OLD_CKYC_MSG',
    res,
    loader: false
});

export const quickKycValidate = (payload) => ({
    type: 'QUICK_KYC_VALIDATE_OTP',
    payload,
    loader: true
});
export const cancelVideoConfirmationDialog = res => ({
    type: 'CANCEL_VIDEO_KYC_DIALOG',
    res
});

export const confirmAdditionalFields = payload => ({
    type: 'CONFIRM_ADDITIONAL_FIELDS',
    payload,
    loader: true
});

export const quickKycValidateOtpRes = res => ({
    type: 'QUICK_KYC_VALIDATE_OTP_RES',
    res,
    loader: false
});

export const quickKycVerify = (payload) => ({
    type: 'QUICK_KYC_VERIFY',
    payload,
    loader: true
});

export const quickKycVerifyRes = res => ({
    type: 'QUICK_KYC_VERIFY_RES',
    res,
    loader: false
});
export const confirmAdditionalFieldsRes = res => ({
    type: 'CONFIRM_ADDITIONAL_FIELDS_RES',
    res,
    loader: false
});
export const isFromDetailsPage = res => ({
    type: 'IS_FROM_DETAILS_PAGE',
    res
});

export const createCif = (payload, msg) => ({
    type: 'CREATE_CIF',
    payload,
    loader: true,
    loaderText: msg
});

export const createCifRes = res => ({
    type: 'CREATE_CIF_RES',
    res,
    loader: false
});

export const quickKycVerifyFailRes = res => ({
    type: 'QUICK_KYC_VERIFY_FAIL_RES',
    res,
    loader: false
});
export const pennyDropVerification = (payload, msg) => ({
    type: 'VERIFY_PENNY_DROP',
    payload,
    loader: true,
    loaderText: msg
});

export const pennyDropVerificationRes = res => ({
    type: 'VERIFY_PENNY_DROP_RES',
    res,
    loader: false
});


export const fetchMetaFields = (payload, msg = "") => ({
    type: 'FETCH_META_FIELDS',
    payload,
    loader: true,
    loaderText: msg
});

export const fetchMetaFieldsRes = res => ({
    type: 'FETCH_META_FIELDS_RES',
    res,
    loader: false
});
export const setMetaFields = payload => ({
    type: 'SET_META_FIELDS',
    payload,
    loader: true
});


export const hdfcVkycPanVerification = (payload, msg) => ({
    type: 'HDFC_VKYC_PAN_VERIFICATION',
    payload,
    loader: true,
    loaderText: msg
});

/////////////// HDFC BANK KYC

export const setHdfcAdditionalData = (payload, msg) => ({
    type: 'HDFC_VKYC_ADDITIONAL_DATA',
    payload,
    loader: true,
    loaderText: msg
});

export const hdfcVkycPanVerificationRes = res => ({
    type: 'HDFC_VKYC_PAN_VERIFICATION_RES',
    res,
    loader: false
});

export const setHdfcAdditionalDataRes = res => ({
    type: 'HDFC_VKYC_ADDITIONAL_DATA_RES',
    res,
    loader: false
});

export const hdfcBankEKYCToken = (payload, msg) => ({
    type: 'HDFC_BANK_EKYC',
    payload,
    loader: true,
    loaderText: msg
});

export const hdfcBankEKYCRes = res => ({
    type: 'HDFC_BANK_EKYC_RES',
    res,
    loader: false
});

export const hdfcBankCheckStepDetails = (payload, msg) => ({
    type: 'HDFC_BANK_STEP_DETAILS',
    payload,
    loader: true,
    loaderText: msg
});

export const hdfcBankStepDetailsRes = res => ({
    type: 'HDFC_BANK_STEP_DETAILS_RES',
    res,
    loader: false
});

export const fetchHdfVkycUserDetails= (payload, msg) => ({
    type: 'HDFC_BANK_VKYC_USER_DETAILS',
    payload,
    loader: true,
    loaderText: msg
});

export const fetchHdfVkycUserDetailsRes = res => ({
    type: 'HDFC_BANK_VKYC_USER_DETAILS_RES',
    res,
    loader: false
});

export const setHdfcBankAddressConfirmation = payload => ({
    type: 'HDFC_BANK_ADDRESS_CONFIRMATION',
    payload,
    loader: true
});

export const setHdfcBankAddressConfirmationRes = res => ({
    type: 'HDFC_BANK_ADDRESS_CONFIRMATION_RES',
    res,
    loader: false
});

export const getHdfcVkycConsent = payload => ({
    type: 'HDFC_VKYC_CONSENT',
    payload,
    loader: true
});

export const getHdfcVkycConsentRes = res => ({
    type: 'HDFC_VKYC_CONSENT_RES',
    res,
    loader: false
});

export const hdfcVkycConsentAccept = payload => ({
    type: 'HDFC_VKYC_CONSENT_ACCEPT',
    payload,
    loader: true
});

export const hdfcBankVKycLink = (payload, msg) => ({
    type: 'HDFC_BANK_VKYC',
    payload,
    loader: true,
    loaderText: msg
});

export const hdfcBankVKycRes = res => ({
    type: 'HDFC_BANK_VKYC_RES',
    res,
    loader: false
});
